export class Message {
  static FetchClientMetaData = 'cmd_fetch_client_meta_data';

  static BlockStatsApi = 'cmd_block_stats_api';
}
